

export class MachinesToggleDto {
    id:number
    constructor(
        id:number
    ){
        this.id=id
    }
}